const { user } = modules;
import { modules } from '@veritone/glc-redux';
import { TDOId } from '@common-modules/universal/models/Brands';
import { selectConfigEngines } from '../selectors';
import callGraphQLApi, {
  GQLApiDispatch,
  GQLApiGetState,
} from '@helpers/callGraphQLApi';

import {
  NOOP,
  CANCEL_JOB_FAILURE,
  CANCEL_JOB_SUCCESS,
  CREATE_ENGINE_JOB_SUCCESS,
  CREATE_ENGINE_JOB_FAILURE,
  CHECK_JOB_STATUS_FAILURE,
  CHECK_JOB_STATUS_SUCCESS,
  CHECK_TASK_STATUS_SUCCESS,
  CHECK_TASK_STATUS_FAILURE,
} from './actions';

/**
 * Create a voice-mask job.
 * @param {{ engineId: string; payload: { targetId: string; } }} payload
 */
export const createEngineJobService =
  ({
    tdoId,
    tdoName,
    payload,
  }: {
    tdoId: TDOId;
    tdoName: string;
    payload: {
      targetId: string;
    };
  }) =>
  async (dispatch: GQLApiDispatch, getState: GQLApiGetState) => {
    // TODO: type the return of getState properly
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const state = getState();
    const { voiceMaskEngineId, defaultClusterId } = selectConfigEngines(state);

    const email = user.selectUser(state).email;

    const voiceMaskEngineOptions = {}; // not using

    // TODO replace this with the generalized generateTasksAndRoutes?
    const query = voiceMaskJobMutation({
      defaultClusterId,
    });

    return await callGraphQLApi<{
      createJob: {
        id: string;
        targetId: TDOId;
        status: string;
      };
    }>({
      actionTypes: [NOOP, CREATE_ENGINE_JOB_SUCCESS, CREATE_ENGINE_JOB_FAILURE],
      query,
      variables: {
        id: tdoId,
        tdoName,
        engineId: voiceMaskEngineId,
        payload: Object.assign({}, voiceMaskEngineOptions, {
          ...payload,
          user: email,
          // Used for email notifications flow in Automate to filter tasks only from REDACT app. DONOT REMOVE.
          app: 'redact',
        }),
      },
      dispatch,
      getState,
    });
  };

const voiceMaskJobMutation = ({
  defaultClusterId,
}: {
  defaultClusterId?: string;
}) => `
    mutation ($id: ID!, $engineId: ID!, $payload: JSONData!){
     createJob(input: {
        targetId: $id,
        clusterId: "${defaultClusterId ?? ''}",
        tasks: [
          {
            engineId: $engineId,
            payload: $payload,
            executionPreferences: {
              maxEngines: 1
              priority: -15
            }
          },
        ],
        routes: []
      }) {
        id
        targetId
        status
      }
    }
  `;

/**
 * Cancel a running job.
 * @param {{ jobId: string }} action
 */
export interface CancelJobServiceResponse {
  cancelJob: {
    id: string;
    message: string;
  };
}
export const cancelJobService =
  ({ jobId }: { jobId: string }) =>
  async (dispatch: GQLApiDispatch, getState: GQLApiGetState) => {
    const query = `
      mutation cancelJob($id: ID!) {'
        cancelJob(id: $id){
          id
          message
        }
      }
    `;

    return await callGraphQLApi<CancelJobServiceResponse>({
      actionTypes: [NOOP, CANCEL_JOB_SUCCESS, CANCEL_JOB_FAILURE],
      query,
      variables: { id: jobId },
      dispatch,
      getState,
      bailout: undefined,
    });
  };

/**
 * Get the status of a job.
 * @param {{ jobId: string }} action
 */
export const checkJobStatusService =
  ({ jobId }: { jobId: string }) =>
  async (dispatch: GQLApiDispatch, getState: GQLApiGetState) => {
    const query = `query($jobId: ID!) {
      job(id: $jobId) {
        id
        targetId
        status
      }
    }`;

    return await callGraphQLApi({
      actionTypes: [NOOP, CHECK_JOB_STATUS_SUCCESS, CHECK_JOB_STATUS_FAILURE],
      query,
      variables: { jobId },
      dispatch,
      getState,
      bailout: undefined,
    });
  };

/**
 * Get the status of a task.
 * @param {{ taskId: string }} action
 */
export const checkTaskStatusService =
  ({ taskId }: { taskId: string }) =>
  async (dispatch: GQLApiDispatch, getState: GQLApiGetState) => {
    const query = `query($taskId: ID!) {
    task(id: $taskId) {
      id
      jobId
      targetId
      status
    }
  }`;

    return await callGraphQLApi({
      actionTypes: [NOOP, CHECK_TASK_STATUS_SUCCESS, CHECK_TASK_STATUS_FAILURE],
      query,
      variables: { taskId },
      dispatch,
      getState,
      bailout: undefined,
    });
  };
